import { applyKeyframe } from '@noths/polaris-client-styles';
import { css, keyframes } from 'styled-components';
var pulseAnimation = function pulseAnimation(from, to) {
  return keyframes(["0%{background-color:", ";}50%{background-color:", ";}100%{background-color:", ";}"], from, to, from);
};
export var pulse = /*#__PURE__*/css(["background-color:var(--neutral-black-30);animation:", " 2s infinite;"], applyKeyframe(pulseAnimation("var(--neutral-black-30)", "var(--neutral-black-70)")));